import { Component, OnInit } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component( {
  templateUrl: 'cuestionarios-listado.component.html',
  selector: 'app-cuestionarios'
} )
export class CuestionariosListadoComponent implements OnInit {

  columnas: any[];
  busqueda: string;
  cuestionarios: Cuestionario[] = [];
  carCuestionarios: boolean;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService,
               private cuestionarioService: CuestionarioService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/cuestionarios' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'CUESTIONARIO.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'CUESTIONARIO.LBL_NOMBRE' ), sort: true },
      { field: 'totalPreguntas', header: this.navServicio.buscarMensaje( 'CUESTIONARIO.LBL_TOTALPREGUNTAS' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: true },
    ];
    this.carCuestionarios = true;
    this.cuestionarioService.listado().subscribe( res => {
      this.carCuestionarios = false;
      this.cuestionarios = res;
    }, e => {
      this.carCuestionarios = false;
    } );
  }

  add(): void {
    this.router.navigate( [ 'apl/cuestionarios/agregar' ] );
  }

  update( cuestionario: Cuestionario ): void {
    this.router.navigate( [ 'apl/cuestionarios/actualizar/' + cuestionario.idCuestionario ] );
  }

  view( cuestionario: Cuestionario ): void {
    this.router.navigate( [ 'apl/cuestionarios/detalle/' + cuestionario.idCuestionario ] );
  }

  setSearch(): void {
    this.navServicio.setSearch( 'cuestionarios.component', this.busqueda );
  }

}
